import React from 'react';
import ModalShell from './shared/ModalShell';
import { useTranslation } from '../contexts/TranslationContext';
import { WHATS_NEW_ITEMS, WhatsNewIcon } from '../constants/whatsNew';

/**
 * WhatsNewDialog — the release notes a person sees once after a release (and can reopen from
 * the profile menu). Content and the when-to-show rule live in constants/whatsNew.ts; this is
 * only the dialog, on THE shared ModalShell.
 */
const ICON_PATHS: Record<WhatsNewIcon, React.ReactNode> = {
  layout: <><rect x="3" y="3" width="18" height="18" rx="2" /><path d="M3 9h18M9 21V9" /></>,
  layers: <><path d="m12 3 9 5-9 5-9-5z" /><path d="m3 13 9 5 9-5" /></>,
  flag: <><path d="M5 21V4" /><path d="M5 4h11l-2 4 2 4H5" /></>,
  tag: <><path d="M3 12V4h8l10 10-8 8z" /><circle cx="7.5" cy="8.5" r="1.5" /></>,
  graph: <><circle cx="6" cy="12" r="2.5" /><circle cx="18" cy="6" r="2.5" /><circle cx="18" cy="18" r="2.5" /><path d="m8.2 10.9 7.6-3.8M8.2 13.1l7.6 3.8" /></>,
  map: <><path d="M9 4 3 6v14l6-2 6 2 6-2V4l-6 2z" /><path d="M9 4v14M15 6v14" /></>,
  grid: <><rect x="3" y="3" width="7" height="7" rx="1" /><rect x="14" y="3" width="7" height="7" rx="1" /><rect x="3" y="14" width="7" height="7" rx="1" /><rect x="14" y="14" width="7" height="7" rx="1" /></>,
};

const WhatsNewDialog: React.FC<{ onClose: () => void }> = ({ onClose }) => {
  const { t } = useTranslation();
  return (
    <ModalShell onClose={onClose} ariaLabel={t('whatsNew_title')} width={520} maxHeight="86%">
      <div className="dt-whatsnew">
        <div className="dt-whatsnew__head">
          <div className="dt-whatsnew__heading">
            <h2 className="dt-whatsnew__title">{t('whatsNew_title')}</h2>
            <div className="dt-whatsnew__sub">{t('whatsNew_subtitle')}</div>
          </div>
          <button type="button" className="dt-whatsnew__close" aria-label={t('close')} onClick={onClose}>
            <svg viewBox="0 0 24 24" aria-hidden="true"><path d="M6 6l12 12M18 6 6 18" /></svg>
          </button>
        </div>
        <ul className="dt-whatsnew__list">
          {WHATS_NEW_ITEMS.map(item => (
            <li key={item.titleKey} className="dt-whatsnew__item">
              <span className="dt-whatsnew__icon">
                <svg viewBox="0 0 24 24" aria-hidden="true">{ICON_PATHS[item.icon]}</svg>
              </span>
              <span className="dt-whatsnew__text">
                <span className="dt-whatsnew__name">{t(item.titleKey)}</span>
                <span className="dt-whatsnew__body">{t(item.bodyKey)}</span>
              </span>
            </li>
          ))}
        </ul>
        <div className="dt-whatsnew__foot">
          <span className="dt-whatsnew__hint">{t('whatsNew_reopenHint')}</span>
          <button type="button" className="dt-btn pri" onClick={onClose}>{t('whatsNew_gotIt')}</button>
        </div>
      </div>
    </ModalShell>
  );
};

export default WhatsNewDialog;
